// PDP v2 tiered offer: sets the form quantity, reprices cards for one-time vs refills, updates the sticky bar.
if (!customElements.get('pdp2-tiers')) {
  customElements.define(
    'pdp2-tiers',
    class Pdp2Tiers extends HTMLElement {
      connectedCallback() {
        this.tiers = [...this.querySelectorAll('.pdp2-tier')];
        this.qty = this.querySelector('[data-pdp2-qty]');
        this.tiers.forEach((t) => {
          t.addEventListener('click', () => this.select(t));
          t.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.select(t); } });
        });
        document.addEventListener('click', (e) => {
          if (e.target.closest('.productSubTickBox')) setTimeout(() => this.render(), 30);
        });
        this.render();
        setTimeout(() => this.render(), 1200);
      }

      money(cents) {
        const fmt = this.dataset.moneyFormat || '${{amount}}';
        const amount = (cents / 100).toFixed(2);
        return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
      }

      subscribed() {
        const box = document.querySelector('.productSubTickBox');
        return !!(box && box.classList.contains('active'));
      }

      select(tier) {
        this.tiers.forEach((t) => {
          const on = t === tier;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        this.render();
      }

      render() {
        const unit = Number(this.subscribed() ? this.dataset.unitSub : this.dataset.unit);
        const compareUnit = Number(this.dataset.compareUnit);
        let active = null;
        this.tiers.forEach((t) => {
          const q = Number(t.dataset.qty);
          const d = Number(t.dataset.discount) || 0;
          const total = Math.round(unit * q * (1 - d / 100));
          const compare = compareUnit * q;
          t.querySelector('[data-total]').textContent = this.money(total);
          const save = compare - total;
          t.querySelector('[data-compare]').textContent = save > 0 ? this.money(compare) : '';
          t.querySelector('[data-save]').textContent = save > 0 ? `Save ${this.money(save)}` : '';
          t.dataset.totalCents = total;
          if (t.classList.contains('is-active')) active = t;
        });
        if (!active) return;
        const q = Number(active.dataset.qty);
        if (this.qty) this.qty.value = q;
        // Sticky bar mirrors the selected tier
        const bar = document.querySelector('product-bar');
        if (bar) {
          const price = bar.querySelector('[data-price]');
          if (price) price.textContent = `${active.dataset.label} · ${this.money(Number(active.dataset.totalCents))}`;
          const barQty = bar.querySelector('input[name="quantity"], input[type="number"]');
          if (barQty) barQty.value = q;
        }
      }
    }
  );
}
